import React from 'react';
import Logout from './Logout';
import '../../assets/Nav.css';

interface NavProps {
  onLogout: () => void;
  checkCurrentUser: () => Promise<void>;
}

const Nav: React.FC<NavProps> = ({ onLogout, checkCurrentUser }) => {
  return (
    <nav>
      <ul className="nav-list">
        <Logout onLogout={onLogout} checkCurrentUser={checkCurrentUser} />
      </ul>
    </nav>
  );
};

export default Nav;
